// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"cc73a773","286":"f5a933cd","442":"8354017f","450":"c5ae525d","808":"d68e3d20","932":"a5754b9d"}[chunkId] + ".chunk.css";
};